/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For PrintablesList page
 */

import React, { Component } from 'react';

export interface IToy {
  toyImage?: string;
  toyDescription?: string;
  toyLink?: string;
}
/**
 *
 * PrintablesList component
 * @extends Component
 */
export class PrintablesList extends Component {
  private readonly toys: IToy[] = [
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1t',
      toyDescription: 'Geoffrey’s guitar solo color by numbers',
      toyLink: '/geoffreys-guitar-solo-color-by-numbers',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDsCE',
      toyDescription: 'Ramadan with Geoffrey',
      toyLink: '/ramadan-with-geoffrey',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxP5',
      toyDescription: 'bike safety hand signals',
      toyLink: '/bike-safety-hand-signals',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1P',
      toyDescription: 'Pokémon activities roundup',
      toyLink: '/pokemon-activities-roundup',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqk',
      toyDescription: 'Color a Rainbow for Crayon Day',
      toyLink: '/color-a-rainbow-for-crayon-day',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqD',
      toyDescription: 'Geoffrey’s pizza party',
      toyLink: '/geoffreys-pizza-party',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1O',
      toyDescription: 'Earth Day Unprintable ',
      toyLink: '/earth-day-unprintable',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1T',
      toyDescription: 'puppy day match ’em up ',
      toyLink: '/puppy-day-match-em-up',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxP8',
      toyDescription: 'Geoffrey and Elephant’s pool time hidden picture puzzle',
      toyLink: '/geoffrey-and-elephants-pool-time-hidden-picture-puzzle',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqI',
      toyDescription: 'Geoffrey and Rhino’s color by numbers cool concert',
      toyLink: '/geoffrey-and-Rhinos-color-by-numbers-cool-concert',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDsCF',
      toyDescription: 'WWE coloring & activity Sheets ',
      toyLink: '/wwe-coloring-and-activity-sheets',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1C',
      toyDescription: 'Earth Day Unprintable ',
      toyLink: '/earth-day-unprintable-2',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqC',
      toyDescription: 'origami butterfly ',
      toyLink: '/origami-butterfly',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1X',
      toyDescription: 'color a thank-you sign ',
      toyLink: '/color-a-thank-you-sign',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDAqf',
      toyDescription: 'dream career with Barbie',
      toyLink: '/dream-career-with-barbie',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDD1I',
      toyDescription: 'connect the dots for a playful peek',
      toyLink: '/connect-the-dots-for-a-playful-peek',
    },
    {
      toyImage:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPh',
      toyDescription: 'be a-maize-d by this popcorn holder!',
      toyLink: '/be-amaized-by-this-popcorn-holder',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-sm-12'>
            <h1 className='toy-heading'>printables</h1>
          </div>
          {this.toys.map((p) => (
            <div className='col-lg-4 col-md-6 col-sm-12'>
              <div className='row product-row'>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='img-link'>
                    <img
                      className='img-responsive'
                      src={p.toyImage}
                      alt={p.toyDescription}
                    />
                  </a>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-6 col-xs-6 product-info'>
                  <a href={p.toyLink} className='toy-link'>
                    {p.toyDescription}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default PrintablesList;
